import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import styled from 'styled-components'

import { cyan, dividerGray, errorD1, midGray } from '../../theme/colors'
import { header3, header4, label4, paragraph2 } from '../../theme/typography'

export const StyledRadio = styled(Radio)<{ $error: boolean }>`
  height: 20px;
  width: 20px;
  margin-left: 10px;

  svg {
    height: 24px;
    width: 24px;
  }

  svg + svg {
    height: 20px;
    width: 20px;
    margin: 2px;
  }

  &.Mui-checked .MuiSvgIcon-root {
    fill: ${cyan};
    ${({ $error }) => $error && `fill: ${errorD1};`}
  }

  .MuiSvgIcon-root {
    fill: ${dividerGray};
    border-radius: 50%;
    ${({ $error }) => $error && `fill: ${errorD1};`}
  }
`

export const Label = styled.label`
  ${header4};
  margin-bottom: 10px;
`

export const Notice = styled.label`
  ${paragraph2};
  color: ${midGray};
  margin-top: -8px;
  margin-bottom: 10px;
`

export const FormControlLabelStyled = styled(FormControlLabel)`
  .MuiTypography-body1 {
    ${header3};
    color: ${midGray};
    margin-left: 10px;
    position: relative;
    top: 2px;
  }

  margin-bottom: 10px;
`

export const ErrorMessage = styled.div`
  ${label4};
  color: ${errorD1};
  position: absolute;
  bottom: -10px;
`
